import { Box, Grid } from "@mui/material";
import { ErrorMessageHandle } from "@platformx/schema-based-content-type";
import { CommonBoxWithNumber, TitleSubTitle } from "@platformx/utilities";
import { XImageRender } from "@platformx/x-image-render";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useCustomStyle } from "../../CreateEvent.styles";
import { ImageThumbnailProp } from "../../CreateEvent.types";

const EventImageAndThumbnail = ({
  state,
  setState,
  eventWholeRef,
  unsavedChanges,
  isError,
  setIsError,
}: ImageThumbnailProp) => {
  const { t } = useTranslation();

  const updateField = (updatedPartialObj) => {
    const relativeUrl = updatedPartialObj?.original_image?.Thumbnail || "";
    setState({
      ...structuredClone(state),
      ...updatedPartialObj,
      thumbnailURL: relativeUrl,
      socialShareImgURL: relativeUrl, //when we update image socialshareimg also needs to update
      notification_image: relativeUrl, //when we update image notification_image also needs to update
    });

    eventWholeRef.current = {
      ...eventWholeRef.current,
      ...updatedPartialObj,
      thumbnailURL: relativeUrl,
      socialShareImgURL: relativeUrl, //when we update image socialshareimg also needs to update
      notification_image: relativeUrl, //when we update image notification_image also needs to update
    };
    unsavedChanges.current = true;
    setIsError({ ...isError, ImageAndThumbnail: false });
  };

  const classes = useCustomStyle();

  return (
    <Box id='ImageAndThumbnail' className={classes.mainStyleWrapper}>
      <CommonBoxWithNumber
        number='02'
        title={t("choose_the_image")}
        titleVarient='h5bold'
        subTitleVarient='p4regular'
        subTitle={t("subhead")}>
        <Grid container>
          <Grid item xs={12} sm={5} md={5} className='leftFiledLast'>
            <TitleSubTitle
              title={`${t("event_image_tilte")}*`}
              subTitle={t("event_image_subtitle")}
              titleVariant='h6medium'
              subTitleVariant='p4regular'
            />
          </Grid>
          <Grid item xs={12} sm={7} md={7} className='textFiledLast' id='imageVideo'>
            <XImageRender
              callBack={updateField}
              editData={{
                original_image: state.original_image,
                published_images: state.published_images,
              }}
            />
            {isError?.["ImageAndThumbnail"] && (
              <ErrorMessageHandle error={{ message: "Field is Required" }} />
            )}
          </Grid>
        </Grid>
      </CommonBoxWithNumber>
    </Box>
  );
};

export default memo(EventImageAndThumbnail);
